import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { LikesDataService, LikesColumnsService } from '../../../services';
import { Like, LikesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-like-details',
  templateUrl: './like-details.component.html',
  styleUrls: ['./like-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class LikeDetailsComponent implements OnInit, OnDestroy {

  public like: Like = {};
  public likes: Like[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private likesDataService: LikesDataService,
    private likesColumnsService: LikesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Like - Details');
        this.getLike(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.like !== 'undefined') {
      this.like = this.dynamicDialogConfig.data.like;
    }
    this.columns = this.likesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getLike(id: number): void {
    this.isLoading = true;
    this.likesDataService.getLike(id).subscribe((response: Like|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.like = response;
      }
    });
  }

  list() {
    this.router.navigate(['/likes']);
  }

  add() {
    this.router.navigate(['/likes/add']);
  }

  edit() {
    this.router.navigate(['/likes/edit/' + this.like.id]);
  }

}
@Component({
  selector: 'app-like-details',
  templateUrl: './like-details.component.html',
  styleUrls: ['./like-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogLikeDetailsComponent extends LikeDetailsComponent {
}

